<template>
  <div class="image-chart" :style="{
    width: config.chartWidth + 'px',
    height: config.chartHeight + 'px',
  }">
    <img v-if="imgUrl" class="image-chart-img" :src="imgUrl" alt=""
         :style="{ display: 'inline-block', width: '100%', height: '100%' }" />
  </div>
</template>

<script>
import ChartMixin from './mixin'
import { imgURLtoBase64 } from '@/utils/common'

export default {
  name: 'ImageBlock',
  mixins: [ChartMixin],
  data () {
    return {
      imgUrl: '',
    }
  },
  computed: {

    chartStyle () {
      return this.config.chartSet.chartStyle
    },
    chartData () {
      return this.config.chartViewData.chartData
    },

  },
  watch: {
    chartData: {
      handler: function (val) {
        this.init()
      },
      deep: true,
    },
    // 配置项变更
    config: {
      handler: function () {
        this.init()
      },
      deep: true,
    },

  },
  async created () {
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      const raw = this.chartData.length > 1 ? this.chartData[1].col_0 : ''
      const src = typeof raw === 'string' ? raw.trim() : (raw != null && raw !== '' ? String(raw).trim() : '')
      if (!src) {
        this.imgUrl = ''
        return
      }
      // data URL 直接展示
      if (src.startsWith('data:')) {
        this.imgUrl = src
        return
      }
      // http(s) / 协议相对 外链：直链即可；转 Base64 需 canvas 同源，跨域常失败导致子屏等场景图片空白
      if (/^https?:\/\//i.test(src) || src.startsWith('//')) {
        this.imgUrl = src
        return
      }
      try {
        const b64 = await imgURLtoBase64(src)
        this.imgUrl = b64 || src
      } catch (e) {
        this.imgUrl = src
      }
    },

  },
}
</script>

<style lang='scss' scoped>
.image-chart {
  display: flex;
  flex-direction: column;
  .image-chart-img{
    width: 100%;
    height: 100%;
    user-select: none;
    -webkit-user-drag: none;
  }
}
</style>
